<template>
  <section class="h-100 w-100 d-flex align-items-center justify-content-center bg-white">
    <div class="p-5 border">
      <div class="d-flex justify-content-center align-items-center pb-1">
        <img width="200" src="./../assets/HMP_COLOR.svg" alt="logo" />
      </div>
      <h1 class="text-center m-4">Reset your password</h1>
      <template v-if="!successful">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="newPassword" label="New password">
            <el-input
              ref="password"
              v-model="form.newPassword"
              type="password"
              name="password"
              :popper-class="'capitalize'"
              size="small"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="verifyPassword" label="Password Confirmation">
            <el-input
              ref="verifyPassword"
              v-model="form.verifyPassword"
              type="password"
              name="verifyPassword"
              :popper-class="'capitalize'"
              size="small"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="submit" class="btn btn-primary mt-3 float-right" @click="onSubmit">submit</el-button>
          </el-form-item>
        </el-form>
      </template>
      <div v-if="successful">
        <div class="mt-4 text-center">
          <template v-if="!isError">
            <i class="fa fa-check-circle text-success mr-2 icon-success"></i>
            <p>Password successfully changed</p>
          </template>
          <template v-else>
            <i class="fa fa-check-circle text-danger mr-2 icon-danger"></i>
            <p>Oops... Something went wrong! Try it later</p>
          </template>
          <button class="btn btn-link mt-3" @click="$router.push({ name: 'login' })">Login</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== '' && this.form.verifyPassword !== '') {
        this.$refs.form.validateField('verifyPassword');
      }
      callback();
    };
    var validatePass2 = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    return {
      form: {
        newPassword: null,
        verifyPassword: null,
      },
      rules: {
        newPassword: [{ validator: validatePass, required: true, trigger: 'blur' }],
        verifyPassword: [{ validator: validatePass2, required: true, trigger: 'blur' }],
      },
      successful: false,
      isError: false,
    };
  },
  // created() {
  //   console.log(this.$route.params.token);
  // },
  methods: {
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$httpMain
            .post(
              `reset-password`,
              {
                password: this.form.newPassword,
              },
              { headers: { Authorization: 'Bearer ' + this.$route.query.token } },
            )
            .then(() => {
              this.successful = true;
              console.log('pssword changed');
            })
            .catch(err => {
              this.successful = true;
              this.isError = true;
              console.log(err);
            });
        }
      });
    },
  },
  resetForm(formName) {
    this.$refs[formName].resetFields();
  },
};
</script>

<style lang="sass">
.btn-primary
  color: white
  background: #148ce0
.icon-success
  font-size: 5em
.icon-danger
  font-size: 5em
.invalid-field
  color: #d50000
  font-size: 12px
</style>
